import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleRequest(
  state: State,
  { strategicAxis }: Boundaries["editStrategicAxis"]["request"],
): State {
  const index = state.findIndex(
    (res) => res.strategicAxis.uuid === strategicAxis.uuid,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        { strategicAxis, request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [...state, { strategicAxis, request: setRequestStateToPending() }];
}

function handleSuccess(
  state: State,
  { strategicAxis }: Boundaries["editStrategicAxis"]["success"],
): State {
  return state.map((res) =>
    res.strategicAxis.uuid === strategicAxis.uuid
      ? { strategicAxis, request: setRequestStateToSuccess() }
      : res,
  );
}

function handleFailure(
  state: State,
  { strategicAxis }: Boundaries["editStrategicAxis"]["failure"],
): State {
  return state.map((res) =>
    res.strategicAxis.uuid === strategicAxis.uuid
      ? { strategicAxis, request: setRequestStateToFailure() }
      : res,
  );
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.editStrategicAxisRequested]: handleRequest,
    [events.editStrategicAxisSucceeded]: handleSuccess,
    [events.editStrategicAxisFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
